import { Box, styled } from '@mui/material';

const StepperAddress = styled(Box)`
  font-weight: normal;
  font-size: 0.85em;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export default StepperAddress;
